import React from 'react'
import { Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { QueryClientProvider } from '@tanstack/react-query'
import { GoogleOAuthProvider } from '@react-oauth/google'

import Routes from './routes'

import history from './services/history'

import GlobalProvider from './contexts/GlobalContext'

import './styles/progress.css'
import './styles/toast.css'
import './styles/editor.css'
import './styles/tooltip.css'
import './styles/tour.css'
import './styles/animations.css'
import './styles/calendar.css'
import 'react-tabs/style/react-tabs.css'

import GlobalStyle from './styles/global'
import TabsStyle from './styles/tabs'
import TooltipStyle from './styles/tooltip2'
import { TipProvider } from './contexts/TipContext'
import { AvatarProvider } from './contexts/AvatarContext'
import { queryClient } from './contexts/ReactQueryContext'

export default function App() {
    return (
        <Router history={history}>
            <QueryClientProvider client={queryClient}>
                <GlobalProvider>
                    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                        <AvatarProvider>
                            <TipProvider>
                                <Routes />
                            </TipProvider>
                        </AvatarProvider>
                    </GoogleOAuthProvider>
                </GlobalProvider>

                <GlobalStyle />

                <TabsStyle />

                <TooltipStyle />

                <ToastContainer
                    position="bottom-right"
                    autoClose={4000}
                    pauseOnHover
                    pauseOnVisibilityChange
                    hideProgressBar
                />
             </QueryClientProvider>
        </Router>
    )
}
